import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col } from 'reactstrap';
import classnames from 'classnames';

const FormStaticText = ({ id, classNameContainer, label, value }) => (
  <FormGroup row className={classnames('form-group-row', classNameContainer)}>
    <Label for={id} className="form-group-row__label">
      {label}
    </Label>
    <Col className="form-group-row__col">
      <div className="form-control-static">{value}</div>
    </Col>
  </FormGroup>
);

FormStaticText.propTypes = {
  id: PropTypes.string,
  classNameContainer: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default FormStaticText;
